import { array_from_query, number_from_query, str_from_query } from "@/api";
import { axios_instance } from "@/api/api";
import { router } from "@/router/router";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import type { recon } from ".";

export const use_recon = () => {
  const keyword = computed(() => str_from_query("keyword"));
  const category = computed(() => array_from_query("category", String));
  const page = computed(() => number_from_query("page", 1));
  const size = computed(() => number_from_query("size", 24));

  const filters = computed(() => ({
    keyword: keyword.value,
    category: category.value,
    page: page.value,
    size: size.value,
    action_id: router.currentRoute.value.params.action_id,
  }));

  const { data, isLoading, error } = useQuery({
    queryKey: ["recon", filters],
    queryFn: async () => {
      const action_id = router.currentRoute.value.params.action_id;
      if (!action_id) return { data: null, total_filter: 0 };

      const response = await axios_instance.post<{
        data: recon[] | null;
        total_filter: number;
      }>("/api/v1/view/recon/pagination", {
        agent_id: router.currentRoute.value.params.client_id,
        action_id,
        page: page.value,
        size: size.value,
        keyword: keyword.value,
        category: category.value,
      });

      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!router.currentRoute.value.params.action_id,
  });

  const recon = computed(() => data.value?.data ?? []);
  const total_filter = computed(() => data.value?.total_filter ?? 0);
  const total_pages = computed(() =>
    Math.max(1, Math.ceil(total_filter.value / size.value)),
  );

  return {
    recon,
    loading: {
      get_recons: isLoading,
    },
    total_filter,
    total_pages,
    error,
  };
};
